import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideAnimation = trigger('slideAnimation', [
  state('void', style({ transform: 'translate3d(0, 0, 0)' })),
  transition('* => left', [
    style({ transform: 'translate3d(0, 0, 0)' }),
    animate('300ms ease-out', style({ transform: 'translate3d(-100vw, 0, 0)' })),
  ]),
  transition('* => right', [
    style({ transform: 'translate3d(0, 0, 0)' }),
    animate('300ms ease-out', style({ transform: 'translate3d(100vw, 0, 0)' })),
  ]),
  transition('* => null', [
    animate('0ms', style({ transform: 'translate3d(0, 0, 0)' }))
  ]),
]);